import { PriceAmountResponseBuilder } from './PriceAmountResponseBuilder';
import { PointsValueResponseBuilder } from './PointsValueResponseBuilder';
import { EarnLoyaltyOfferResponseBuilder } from './EarnLoyaltyOfferResponseBuilder';
import { BurnLoyaltyOfferResponseBuilder } from './BurnLoyaltyOfferResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class LoyaltyOfferResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('LoyaltyOffer');
    }
    public withLoyaltySplitTenderId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['loyaltySplitTenderId'] = this.initField(null, args);
        return this;
    }

    public withLoyaltyToken = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['loyaltyToken'] = this.initField(null, args);
        return this;
    }

    public withPayableAmount = (builder: PriceAmountResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['payableAmount'] = this.initField(builder, args);
        return this;
    }

    public withLoyaltyOfferType = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['loyaltyOfferType'] = this.initField(null, args);
        return this;
    }

    public withNoOfPoints = (builder: PointsValueResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['noOfPoints'] = this.initField(builder, args);
        return this;
    }

    public withIsSelected = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isSelected'] = this.initField(null, args);
        return this;
    }

    public withTotalOfferCostInPoints = (builder: PointsValueResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['totalOfferCostInPoints'] = this.initField(builder, args);
        return this;
    }

    public withEarnOffer = (builder: EarnLoyaltyOfferResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['earnOffer'] = this.initField(builder, args);
        return this;
    }

    public withBurnOffer = (builder: BurnLoyaltyOfferResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['burnOffer'] = this.initField(builder, args);
        return this;
    }
}
